// 9fbef606107a605d69c0edbcd8029e5d
/* stylelint-disable no-descending-specificity */
import styled from 'styled-components';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Skeleton from '@tcp/core/src/components/common/atoms/Skeleton';

export const StyledTabSection = styled.section`
  padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
  @media ${(props) => props.theme.mediaQuery.large} {
    margin: 0 ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
  }

  .slick-slider {
    line-height: 20px;
  }
  .slick-slide:last-child {
    width: 265px !important;
  }

  .slick-slide > div {
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.XXM};
    padding-bottom: 0;
  }
  .slick-prev {
    left: 0;
  }
  .slick-next {
    right: 0;
  }

  .slick-prev,
  .slick-next {
    height: 42px;
    width: 40px;
    background-color: ${(props) => props.theme.colorPalette.white};
    @media ${(props) => props.theme.mediaQuery.medium} {
      top: 20px;
    }
  }
`;

export const StyledProductSection = styled.section`
  padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
  @media ${(props) => props.theme.mediaQuery.large} {
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
    padding-bottom: 0;
  }

  .slick-slider {
    line-height: 20px;
  }
  .slick-prev {
    left: 0;
  }
  .slick-next {
    right: 0;
  }
  .slick-prev,
  .slick-next {
    height: 38px;
    width: 40px;
    border: 1px solid ${(props) => props.theme.colors.PRIMARY.GRAY};
    border-radius: 20px;
    background-color: ${(props) => props.theme.colorPalette.white};

    &:hover {
      background-color: ${(props) => props.theme.colorPalette.gray[300]};
    }
  }
  .slick-slide {
    display: flex !important;
    justify-content: center;
  }
`;

export const StyledSkeleton = styled(Skeleton)`
  justify-content: center;
  margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XS_1};
  .skeleton-col {
    height: 200px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      &:nth-child(n + 4) {
        display: none;
      }
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      height: 285px;
      &:nth-child(n + 5) {
        display: none;
      }
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      height: 387px;
      &:nth-child(n + 8) {
        display: none;
      }
    }
  }
`;

export const StyledProductName = styled.p`
  margin: ${(props) => props.theme.spacing.ELEM_SPACING.XXS} 0;
  color: ${(props) => props.theme.colors.ANCHOR.PRIMARY};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    font-size: ${(props) => props.theme.typography.fontSizes.fs13};
  }
  @media ${(props) => props.theme.mediaQuery.small} {
    white-space: break-spaces;
  }
`;

export const StyledProduct = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  .moduleTabbed_carousel_img {
    display: flex;
    max-width: 168px;
    min-height: 207px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      min-height: 185px;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      min-height: 309px;
    }
  }
`;

export const StyledPriceSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  .list-price {
    text-decoration: line-through;
  }
`;

export const StyledRatingSection = styled.div`
  height: 13px;
`;

export const StyledButton = styled.div`
  display: flex;
  justify-content: center;
`;

export const StyledProductWrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
  gap: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
  box-sizing: border-box;
  width: 100%;
  min-height: 290px;
  ${(props) =>
    props.isBgColorPassed
      ? `
  background-color: ${props.theme.colors.WHITE};
  border-radius: ${props.theme.spacing.ELEM_SPACING.XS};
  `
      : `
    border-radius: ${props.theme.spacing.ELEM_SPACING.XS};
    ${
      !props.isTabbedProductTileBorderDisabled
        ? `border: solid 1px ${props.theme.colors.BORDER.GRAY};`
        : ``
    }
  `};
  @media ${(props) => props.theme.mediaQuery.large} {
    min-width: 250px;
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
  }
`;

export const StyledBrandTitle = styled(BodyCopy)`
  display: flex;
  align-items: center;
  font-weight: ${(props) => props.theme.typography.fontWeights.demiBold};
  font-size: ${(props) => props.theme.typography.fontSizes.fs10};
  color: ${(props) => props.theme.colors.TEXT.BRANDGRAY};
  margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XXM}; ;
`;

export const StyledProductDetails = styled.section`
  width: 100%;
`;

export const ATBIcon = styled.button`
  padding: 0;
  border: 0;
  position: relative;
  box-sizing: border-box;
  cursor: pointer;

  &,
  .tab-atb-icon-image {
    width: ${(props) => props.theme.spacing.ELEM_SPACING.XL};
    height: ${(props) => props.theme.spacing.ELEM_SPACING.XL};
    border-radius: 50%;
    @media ${(props) => props.theme.mediaQuery.large} {
      width: ${(props) => props.theme.spacing.ELEM_SPACING.XXML};
      height: ${(props) => props.theme.spacing.ELEM_SPACING.XXML};
    }
  }

  .tab-atb-icon-image {
    position: absolute;
    top: 0;
    left: 0;
  }
`;

export const ColorSwatchWrapper = styled.div`
  height: 16px;
  margin-bottom: 8px;
  margin-top: 12px;
  @media ${(props) => props.theme.mediaQuery.large} {
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
  }
  .color-swatch-list {
    padding: 0;
    box-sizing: border-box;
    margin: 1px 0px;
    display: flex;
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
    -ms-overflow-style: none;
    scrollbar-width: none;
    width: 100%;
    &::-webkit-scrollbar {
      display: none;
    }
  }
`;
